import InsightsCompetitorsItem from "./insights-competitors-item";

export default InsightsCompetitorsItem;
